export const FILTER_PLATFORM = [{
    code: "android",
    label: "Android"
}, {
    code: "ios",
    label: "iOS"
}
];

export const FILTER_STATUS = [{
    code: "online",
    label: "Online"
}, {
    code: "offline",
    label: "Offline"
}];

export const FILTER_BAN_STATUS = [{
    code: "0",
    label: "Not banned"
}, {
    code: "any",
    label: "Any ban"
}, {
    code: "1",
    label: "Permanent"
}, {
    code: "2",
    label: "Temporary"
}];

export const FILTER_LEAGUES = [{
    code: "non_ranked",
    label: "Not ranked"
}, {
    code: "wildcard_3",
    label: "Wildcard"
}, {
    code: "bronze_3",
    label: "Bronze 3"
}, {
    code: "bronze_2",
    label: "Bronze 2"
}, {
    code: "bronze_1",
    label: "Bronze 1"
}, {
    code: "silver_3",
    label: "Silver 3"
}, {
    code: "silver_2",
    label: "Silver 2"
}, {
    code: "silver_1",
    label: "Silver 1"
}, {
    code: "gold_3",
    label: "Gold 3"
}, {
    code: "gold_2",
    label: "Gold 2"
}, {
    code: "gold_1",
    label: "Gold 1"
}, {
    code: "diamond_3",
    label: "Diamond 3"
}, {
    code: "diamond_2",
    label: "Diamond 2"
}, {
    code: "diamond_1",
    label: "Diamond 1"
}, {
    code: "masters_3",
    label: "Masters 3"
}, {
    code: "masters_2",
    label: "Masters 2"
}, {
    code: "masters_1",
    label: "Masters 1"
}];
